import { SINGLE_PRIMARY_CONTACT_MESSAGE } from './constraints.js';
/** Flags every primary contact after the first, so the error lands on the row that broke the rule. */
export function refineSinglePrimaryContact(contacts, context) {
    let primarySeen = false;
    contacts.forEach((contact, index) => {
        if (contact.defaultFlag !== true)
            return;
        if (primarySeen) {
            context.addIssue({
                code: 'custom',
                message: SINGLE_PRIMARY_CONTACT_MESSAGE,
                path: [index, 'defaultFlag'],
            });
        }
        primarySeen = true;
    });
}
//# sourceMappingURL=refine-single-primary-contact.js.map